import styled, { css } from 'styled-components';

interface VariantProps {
  $variant: 'hero' | 'footer';
}

export const NoteWrapper = styled.div<VariantProps>`
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  margin-top: 1.25rem;
  max-width: 420px;

  ${({ $variant }) =>
    $variant === 'hero' &&
    css`
      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        justify-content: center;
        margin-left: auto;
        margin-right: auto;
        text-align: left;
      }
    `}
`;

export const NoteIcon = styled.span<VariantProps>`
  flex-shrink: 0;
  font-size: 1rem;
  margin-top: 1px;
  color: ${({ $variant, theme }) =>
    $variant === 'hero' ? 'rgba(255,255,255,0.6)' : theme.colors.textMuted};
`;

export const NoteText = styled.span<VariantProps>`
  font-size: 0.78rem;
  line-height: 1.45;
  color: ${({ $variant, theme }) =>
    $variant === 'hero' ? 'rgba(255,255,255,0.55)' : theme.colors.textMuted};
`;
